import * as actionTypes from './actionTypes'

const initialState = {
    planDetails: [],
    planServiceDetails: []
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.UPDATE_PLAN_DETAILS:
            state = {
                ...state,
                [action.payload.name]: action.payload.data,
            }
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default reducer;
